import * as React from 'react';

function SvgPublishProperty(props) {
  return (
    <svg
      width={124}
      height={125}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="publish-property_svg__a" d="M0 0h160v160H0z" />
      </defs>
      <g transform="translate(-16 -19)" fill="none" fillRule="evenodd">
        <mask id="publish-property_svg__b" fill="#fff">
          <use xlinkHref="#publish-property_svg__a" />
        </mask>
        <g mask="url(#publish-property_svg__b)">
          <path
            d="M98.358 81.906l-42.374 29.567L16 54.168 52.657 28.59l4.307.468 4.89.532 36.504 52.316"
            fill="#FCFBFC"
          />
          <path fill="#9EA0A0" d="M52.657 28.59l3.48 4.988 5.717-3.988-9.197-1" />
          <path
            fill="#CCCDC9"
            d="M44.348 61.575L32.444 69.88l-8.306-11.904 11.903-8.306 8.307 11.904M57.572 37.75L41.252 49.14l-1.024-1.466L56.55 36.286l1.023 1.465m2.138 3.065L43.39 52.204l-1.023-1.466 16.32-11.387 1.023 1.465m2.139 3.066l-16.32 11.387-1.023-1.465 16.32-11.388 1.023 1.466m2.139 3.065l-16.32 11.388-1.023-1.466 16.32-11.388 1.023 1.466m-8.253 30.947L43.83 86.201l-8.306-11.904 11.904-8.306 8.306 11.903M68.959 54.07L52.639 65.46l-1.023-1.466 16.32-11.388 1.023 1.465m2.139 3.066l-16.32 11.387-1.023-1.465 16.32-11.388 1.023 1.466m2.139 3.065L56.916 71.59l-1.023-1.466 16.321-11.387 1.023 1.465m2.138 3.065l-16.32 11.388-1.023-1.465L74.352 61.8l1.023 1.465m-8.253 30.948l-11.904 8.307-8.306-11.905 11.904-8.305 8.306 11.903M80.346 70.39l-16.32 11.388-1.023-1.466 16.32-11.387 1.023 1.465m2.139 3.066l-16.32 11.387-1.023-1.466 16.32-11.387 1.023 1.466m2.139 3.065l-16.32 11.387-1.023-1.465L83.6 75.055l1.023 1.466m2.139 3.064l-16.32 11.389-1.024-1.466L85.74 78.121l1.023 1.464"
          />
          <path
            d="M75.576 19.593l56.005 20.385a6 6 0 013.586 7.69l-30.312 83.282a8 8 0 01-10.254 4.781l-52.247-19.016a8 8 0 01-4.78-10.254L67.884 23.18a6 6 0 017.69-3.586z"
            fill="#F9CA5B"
          />
          <path
            d="M108.942 20.257a5.07 5.07 0 10-6.468 7.81 5.07 5.07 0 006.468-7.81zm-4.61 5.566a2.158 2.158 0 112.754-3.322 2.158 2.158 0 01-2.754 3.322z"
            fill="#F9A600"
          />
          <path fill="#F9A600" d="M86.3 19.687l37.566 13.672-2.448 6.729-37.566-13.673z" />
          <path fill="#E5E6E3" d="M78.483 27.078l-39.318 75.2 52.596 27.417 38.72-75.94z" />
          <path fill="#FFF" d="M72.84 28.757l55.507 20.203-28.774 79.056-55.508-20.203z" />
          <path
            fill="#EBE9E5"
            d="M66.32 73.715l39.284 14.298-2.04 5.608-39.285-14.299zm-4.487 11.428l39.285 14.298-2.04 5.607L59.792 90.75zM57.416 97.28L96.7 111.579l-2.04 5.607-39.285-14.298z"
          />
          <g transform="rotate(20 -70.573 238.908)">
            <circle fill="#38B2A6" cx={11.255} cy={11.255} r={11.255} />
            <path
              d="M5.838 10.319l5.014-4.531a.58.58 0 01.8 0l2.487 2.246v-.401c0-.147.112-.268.25-.268h.687c.137 0 .25.12.25.268v1.483l1.338 1.203a.689.689 0 01.075.922.587.587 0 01-.863.08l-.075-.066v5.213c0 .226-.175.414-.387.414h-2.862v-4.825H9.977v4.825H7.114c-.213 0-.388-.188-.388-.414v-5.213l-.075.066a.587.587 0 01-.4.16.628.628 0 01-.475-.226c-.225-.294-.188-.709.062-.936"
              fill="#FFF"
            />
          </g>
          <path
            d="M27.808 138.039a3.654 3.654 0 01-3.654-3.654V70.66a3.654 3.654 0 013.654-3.654h100.976a3.654 3.654 0 013.654 3.654v63.726a3.653 3.653 0 01-3.654 3.654H27.808z"
            fill="#2C312F"
          />
          <path
            d="M126.076 134.547h-95.56c-1.91 0-3.458-1.476-3.458-3.296V73.792c0-1.82 1.549-3.295 3.459-3.295h95.559c1.91 0 3.458 1.476 3.458 3.295v57.46c0 1.82-1.548 3.295-3.458 3.295"
            fill="#8BD0C9"
          />
          <path fill="#EEF1EF" d="M16.679 140.528h123.235v-4.427H16.679z" />
          <path
            d="M78.296 140.528H16.68l2.509.798c4.451 1.418 9.57 2.169 14.792 2.169h88.633c5.221 0 10.34-.75 14.792-2.169l2.509-.798H78.296"
            fill="#C7C7C4"
          />
          <path fill="#FCFBFC" d="M34.02 134.547h88.551V62.762h-88.55z" />
          <path
            d="M34.02 62.715h88.551a6.713 6.713 0 00-6.713-6.713H40.734a6.713 6.713 0 00-6.713 6.713z"
            fill="#3A3B39"
          />
          <path
            d="M47.006 59.138a1.18 1.18 0 11-2.36 0 1.18 1.18 0 012.36 0m4.867 0a1.18 1.18 0 11-2.362 0 1.18 1.18 0 012.362 0"
            fill="#B5B7B4"
          />
          <path d="M42.14 59.138a1.18 1.18 0 11-2.362 0 1.18 1.18 0 012.362 0" fill="#E05E55" />
          <g>
            <path fill="#EBE9E5" d="M111.049 83.076l-36 .032v-5.964l36-.036v5.968" />
            <path
              fill="#38B2A6"
              fillRule="nonzero"
              d="M63.448 73.01l2.231 2.642-12.015 10.147-5.985-7.131 2.649-2.223 3.754 4.474z"
            />
          </g>
          <g>
            <path fill="#EBE9E5" d="M111.049 102.056l-36 .052v-5.951l36-.049v5.948" />
            <path
              fill="#38B2A6"
              fillRule="nonzero"
              d="M63.448 92.01l2.231 2.642-12.015 10.147-5.985-7.131 2.649-2.223 3.754 4.474z"
            />
          </g>
          <g>
            <path fill="#EBE9E5" d="M111.049 121.056l-36 .052v-5.951l36-.049v5.948" />
            <path
              fill="#38B2A6"
              fillRule="nonzero"
              d="M63.448 111.01l2.231 2.642-12.015 10.147-5.985-7.131 2.649-2.223 3.754 4.474z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgPublishProperty;
